import { groupBy } from "../../../utility/common-methods";
import { getLineGraphFormat, getRandomUniqueColor } from "./format-utils";
import {
  CONSTANTS,
  GRAPH_TYPES,
  REPORT_TYPES,
  VERTICALS,
} from "../../../constants/app-constant";
import { formatDataByTrend } from "./format-data-by-trend";
import { formatDataByTonality } from "./format-data-by-tonality";
import { formatDataByRanking } from "./format-data-by-ranking";
const { AREA } = GRAPH_TYPES;
const {
  REPORTS: { TYPES },
} = CONSTANTS;

const {
  PublicationTonalityNOARanking,
  PublicationTonalityMAVRanking,
  PublicationTonalityCCMRanking,
  PublicationCCMTrend,
  PublicationMAVTrend,
  PublicationNOATrend,
  TopPublicationWordCount,
  TopPublicationTrendWordCount,
  PublicationTonalityWCRanking,
} = REPORT_TYPES;

export const formatDataByPublication = (
  d = [],
  graph_type,
  isLineGraph,
  type,
  report_type
) => {
  if (
    report_type === PublicationTonalityNOARanking ||
    report_type === PublicationTonalityMAVRanking ||
    report_type === PublicationTonalityCCMRanking ||
    report_type === PublicationTonalityWCRanking
  ) {
    return formatDataByTonality(d, graph_type, isLineGraph, type, report_type);
  }
  if (
    report_type === PublicationCCMTrend ||
    report_type === PublicationMAVTrend ||
    report_type === PublicationNOATrend ||
    report_type === TopPublicationTrendWordCount
  ) {
    return formatDataByTrend(d, graph_type, isLineGraph, type, report_type);
  }

  if (report_type === TopPublicationWordCount) {
    return formatDataByRanking(d, graph_type, isLineGraph, type, report_type);
  }
  try {
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const {
      graphDataType: { print, online },
      groupByField,
      countKey,
      entityKey,
    } = reportType;
    const rType = type === VERTICALS.V_PRINT ? print : online;
    let dataByReportType = d[rType] && d[rType].returnData;
    const groupedDataByEntityName = groupBy(dataByReportType, entityKey) || {};
    const groupedDataByPublication =
      groupBy(dataByReportType, groupByField) || {};
    const listOfEntities = Object.keys(groupedDataByEntityName);
    const listOfPublications = Object.keys(groupedDataByPublication);

    const labels = isLineGraph
      ? getLineGraphFormat(listOfPublications, true)
      : listOfPublications;
    const graphColors = getRandomUniqueColor(listOfPublications.length);
    const datasets = listOfEntities.map((ent, index) => {
      let data = listOfPublications.map((pub) => {
        const pubObj = groupedDataByPublication[pub];
        const entityForPub = pubObj.filter((e) => ent === e[entityKey])[0];
        return (entityForPub && entityForPub[countKey]) || "0";
      });
      data = isLineGraph ? getLineGraphFormat(data) : data;
      return {
        label: ent,
        backgroundColor:
          graph_type === AREA && typeof window.Color === "function"
            ? window.Color(graphColors[index]).alpha(0.5).rgbString()
            : graphColors[index],
        borderColor: graphColors[index],
        borderWidth: 1,
        data,
        barThickness: "flex",
        fill: graph_type === AREA ? "start" : false,
        lineTension: 0,
        minBarLength: 1,
      };
    });
    return {
      datasets,
      labels,
    };
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};
